var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.type === 'danger' || _vm.type === 'warning') && _vm.text)?_c('div',{staticClass:"limit-tip",class:[_vm.type],on:{"click":_vm.showGuide}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95200f62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/timeline/limitTip.vue
// module id = null
// module chunks = 